var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocaleRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2499_41023",
    transform: "translate(-0.248503) scale(0.00598802)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2499_41023",
    width: 250,
    height: 167,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAACnCAYAAAA4/EEUAAAAAXNSR0IArs4c6QAABIBJREFUeF7t00ERQgEMxNBfIxjgwhUNeEMGBzwgAwEoKTPIIK8Okm5md/dwDDDw1wZG6H/9X3AM/AwI3RAYCBgQeuDJEBkQug0wEDAg9MCTITIgdBtgIGBA6IEnQ2RA6DbAQMCA0ANPhsiA0G2AgYABoQeeDJEBodsAAwEDQg88GSIDQrcBBgIGhB54MkQGhG4DDAQMCD3wZIgMCN0GGAgYEHrgyRAZELoNMBAwIPTAkyEyIHQbYCBgQOiBJ0NkQOg2wEDAgNADT4bIgNBtgIGAAaEHngyRAaHbAAMBA0IPPBkiA0K3AQYCBoQeeDJEBoRuAwwEDAg98GSIDAjdBhgIGBB64MkQGRC6DTAQMCD0wJMhMiB0G2AgYEDogSdDZEDoNsBAwIDQA0+GyIDQbYCBgAGhB54MkQGh2wADAQNCDzwZIgNCtwEGAgaEHngyRAaEbgMMBAwIPfBkiAwI3QYYCBgQeuDJEBkQug0wEDAg9MCTITIgdBtgIGBgnq/PBjghMpA2MMf1IfT0BMAXDAi98GWMeQNCz0+AgIIBoRe+jDFvQOj5CRBQMCD0wpcx5g0IPT8BAgoGhF74Msa8AaHnJ0BAwYDQC1/GmDcg9PwECCgYEHrhyxjzBoSenwABBQNCL3wZY96A0PMTIKBgQOiFL2PMGxB6fgIEFAwIvfBljHkDQs9PgICCAaEXvowxb0Do+QkQUDAg9MKXMeYNCD0/AQIKBoRe+DLGvAGh5ydAQMGA0Atfxpg3IPT8BAgoGBB64csY8waEnp8AAQUDQi98GWPegNDzEyCgYEDohS9jzBsQen4CBBQMCL3wZYx5A0LPT4CAggGhF76MMW9A6PkJEFAwIPTClzHmDQg9PwECCgaEXvgyxrwBoecnQEDBgNALX8aYNyD0/AQIKBgQeuHLGPMGhJ6fAAEFA0IvfBlj3oDQ8xMgoGBA6IUvY8wbEHp+AgQUDAi98GWMeQNCz0+AgIIBoRe+jDFvQOj5CRBQMCD0wpcx5g0IPT8BAgoG5n65bQEUIwNlA/M+n4ReXgD2hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8YEHrizSDrBoReXwD+hAGhJ94Msm5A6PUF4E8Y+AIVk7wXTnx+KwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocaleRu);
export default __webpack_public_path__ + "static/media/locale_ru.d405c67f801a5e6d82043e7a38ff192b.svg";
export { ForwardRef as ReactComponent };